/**
 * ResourceSet Sagas
 */

import { put, takeLatest, call } from 'redux-saga/effects';
import contentfulClient from '@artemis/integrations/contentful/client';
import { getCachedOrFetch } from '@artemis/integrations/contentful/cache';
import {
  loadResourceSet,
  loadResourceSetError,
  loadResourceSetSuccess,
} from './slice';

export function* loadResourceSetSaga(action) {
  const {
    payload: { name, locale },
  } = action;
  try {
    // Create cache key based on query parameters
    const cacheKey = `resourceSet:${name.sort().join(',')}:${locale}`;

    // Use caching layer to reduce Contentful API calls
    const data = yield call(getCachedOrFetch, cacheKey, async () =>
      contentfulClient.getClient().getEntries({
        content_type: 'resourceSet',
        'fields.name[in]': name.join(','),
        include: 2,
        locale,
      }),
    );

    yield put(loadResourceSetSuccess(data));
  } catch (error) {
    yield put(loadResourceSetError({ error }));
  }
}

export default function* resourceSetData() {
  yield takeLatest(loadResourceSet.type, loadResourceSetSaga);
}
